import TopStrip from "./components/TopStrip";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import FeaturedEvent from "./components/FeaturedEvent";
import Timeline from "./components/Timeline";
import KeyNodes from "./components/KeyNodes";
import BehindScene from "./components/BehindScene";
import MoreEvents from "./components/MoreEvents";
import Promo from "./components/Promo";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="flex min-h-screen flex-col bg-background-50 text-foreground-950">
      <TopStrip />
      <Navbar />
      <main className="flex-1">
        <Hero />
        <FeaturedEvent />
        <Timeline />
        <KeyNodes />
        <BehindScene />
        <MoreEvents />
        <Promo />
      </main>
      <Footer />
    </div>
  );
}